import React from 'react';
import '../../styles/App.css';
import TeamReportsList from '../../features/teams/TeamReportsList';

function TeamsReportsPage() {
  return (
    <div className="Reports-Page-Container">
          <TeamReportsList />
    </div>
  );
}

export default TeamsReportsPage;